export default __webpack_public_path__ + "static/media/77-Brid Spa-329.847e970b.jpg";